export interface BusinessCard {
  id: string;
  userId: string;
  userName: string;
  name: string;
  role: string;
  company: string;
  department: string;
  unit: string;
  email: string;
  phone: string;
  personalTel?: string;
  website: string;
  photo?: string; // Base64
  status: 'Pending' | 'Approved' | 'Rejected';
  rejectionReason?: string;
  createdAt: string;
}

const STORAGE_KEY = 'business_cards_data';

export const storage = {
  getCards: (): BusinessCard[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  },

  getCardByUserId: (userId: string): BusinessCard | undefined => {
    const cards = storage.getCards();
    return cards.find(card => card.userId === userId);
  },

  getCardById: (id: string): BusinessCard | undefined => {
    const cards = storage.getCards();
    return cards.find(card => card.id === id);
  },

  saveCard: (card: Omit<BusinessCard, 'id' | 'createdAt' | 'status'>): BusinessCard => {
    const cards = storage.getCards();
    const existing = cards.find(c => c.userId === card.userId);
    
    if (existing && existing.status !== 'Rejected') {
      throw new Error('You already have an active or pending business card.');
    }

    const newCard: BusinessCard = {
      ...card,
      id: Math.random().toString(36).substr(2, 9),
      status: 'Pending',
      createdAt: new Date().toISOString(),
    };

    if (existing) {
      // Replace rejected card
      const index = cards.indexOf(existing);
      cards[index] = newCard;
    } else {
      cards.push(newCard);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(cards));
    return newCard;
  },

  updateStatus: (id: string, status: 'Approved' | 'Rejected', reason?: string): void => {
    const cards = storage.getCards();
    const index = cards.findIndex(c => c.id === id);
    if (index !== -1) {
      cards[index].status = status;
      if (reason) cards[index].rejectionReason = reason;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cards));
    }
  }
};
